<script>
  import GroupedPlayerMarketComponent from "./component-grouped-player-market.vue";
  import SinglePlayerMarketsComponent from "./component-single-player-markets.vue";
  import SimplePlayerMarketUSComponent from "./component-simple-player-market-us.vue";
  import GroupedPlayerMarketUSComponent from "./component-grouped-player-market-us.vue";
  import GroupedPlayerMarketUSComponentSpecial from "./component-grouped-player-market-special-us.vue";
  import { LAYOUT_NAME } from '../../../../models/enums/layout-const';

  export default {
    components: { GroupedPlayerMarketComponent, SinglePlayerMarketsComponent, GroupedPlayerMarketUSComponentSpecial },
    functional: true,
    name: "PlayerMarketsComponent",
    props: {
      groups: {
        type: Array,
        required: true,
      },
      match: {
        type: Object,
        required: true,
      },
      showMarkets: {
        type: Boolean,
        default: true,
      },
      selectedMarket: {
        type: String,
      },
    },
    render(_h, { props }) {
      const expandedSlice = (+APP_SETTINGS.matchDetails.matchDetailsExpandedMarkets) || 0;
      return [
        ...props.groups.map((group, i) => {
          const idx = `${props.selectedMarket || ''}pm_${i}`;
          if (group.groupedMarkets.length > 0) {
            return APP_SETTINGS.settings.layout === LAYOUT_NAME.US ? <GroupedPlayerMarketUSComponent key={idx} group={group} match={props.match} /> : <GroupedPlayerMarketComponent key={idx} group={group} match={props.match} />
          } else if (group.groupedOutcomes.length > 0) {
            return APP_SETTINGS.settings.layout === LAYOUT_NAME.US ? <GroupedPlayerMarketUSComponentSpecial key={idx} group={group} match={props.match} showMarket={props.showMarkets && (i < expandedSlice)} /> : <GroupedPlayerMarketComponent key={idx} group={group} match={props.match} />
          }
          return group.simpleMarkets.map((market, mIdx) =>
            APP_SETTINGS.settings.layout === LAYOUT_NAME.US ? <SimplePlayerMarketUSComponent key={`${idx}_${mIdx}`} group={group} match={props.match} market={market} /> : <SinglePlayerMarketsComponent key={`${idx}_${mIdx}`} group={group} match={props.match} market={market} />
          )
        })
      ];
    },
  };
</script>